<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">{{ titulo }} Puertas</h1>
                <v-layout align-center>
                    <v-flex>
                        <router-link exact :to="'/presupuesto/' + presup" class="display-1">Presupuesto Nº {{ presup }}</router-link>
                    </v-flex>
                    <v-flex xs2>
                        <revisiones @change="revisionMostrar()" v-model="revision" :id.sync="d.id"></revisiones>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <empresa-select v-model="d.empresa_id" validate="required"></empresa-select>
            </v-flex>
            <v-flex>
                <ubicacion-select v-model="d.ubicacion" validate="required"></ubicacion-select>
            </v-flex>
            <v-flex>
                <v-text-field v-model="d.plazo_entrega" label="Plazo de entrega en días" validate="required"></v-text-field>
                <!--                <v-menu-->
                <!--                        ref="menuFechaEntrega"-->
                <!--                        :close-on-content-click="false"-->
                <!--                        v-model="menuFechaEntrega"-->
                <!--                        :nudge-right="40"-->
                <!--                        :return-value.sync="d.fecha_entrega"-->
                <!--                        lazy-->
                <!--                        transition="scale-transition"-->
                <!--                        offset-y-->
                <!--                        full-width-->
                <!--                        min-width="290px"-->
                <!--                >-->
                <!--                    <v-text-field-->
                <!--                            slot="activator"-->
                <!--                            v-model="d.fecha_entrega"-->
                <!--                            label="Fecha de Entrega"-->
                <!--                            prepend-icon="event"-->
                <!--                            readonly-->
                <!--                            persistent-hint-->
                <!--                            clearable-->
                <!--                            hint="Fecha negociada entre la empresa y el cliente"-->
                <!--                            :error-messages="errores.collect('fecha_entrega')"-->
                <!--                            v-validate="'required'"-->
                <!--                            data-vv-name="fecha_entrega"-->
                <!--                            required-->

                <!--                    ></v-text-field>-->
                <!--                    <v-date-picker v-model="d.fecha_entrega" scrollable locale="es-sp">-->
                <!--                        <v-spacer></v-spacer>-->
                <!--                        <v-btn flat color="error" @click="menuFechaEntrega = false">Cancelar</v-btn>-->
                <!--                        <v-btn flat color="success" @click="$refs.menuFechaEntrega.save(d.fecha_entrega)">Confirmar</v-btn>-->
                <!--                    </v-date-picker>-->
                <!--                </v-menu>-->
            </v-flex>
            <v-flex>
                <v-checkbox label="¿Para stock?" v-model="d.stock"></v-checkbox>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <form @submit.prevent="guardar()">
                    <v-card>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <item-select
                                            v-model="item"
                                            :id.sync="d.item_id"
                                            :tipo="6"
                                            required
                                            :preset="item"
                                            @input="traePrecio(d.kit_id,'kit_pu')"
                                    ></item-select>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.cant"
                                                  label="Cantidad"
                                                  :error-messages="errores.collect('cant')"
                                                  v-validate="'required|mayor'"
                                                  data-vv-name="cant"
                                                  type="number"
                                                  required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.ancho" label="Ancho" type="number"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.alto" label="Alto" type="number"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.pue_capilla_ancho" label="Capilla Ancho" type="number"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.pue_capilla_alto" label="Capilla Alto" type="number"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.pue_esp_panel" label="Espesor Panel" type="number"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field v-model="d.pue_esp_piso" label="Espesor Piso" type="number"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-select clearable v-model="d.pue_apertura" label="Apertura" :items="aperturas"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm3>
                                    <v-select clearable v-model="d.pue_proteccion" label="Proteccion" :items="protecciones"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-radio-group v-model="d.pue_temp" row label="Temperatura">
                                        <v-radio label="BT" value="bt"></v-radio>
                                        <v-radio label="MT" value="mt"></v-radio>
                                        <v-radio label="AT" value="at"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex>
                                    <v-checkbox v-model="d.pue_defensa" label="Defensa" hide-details></v-checkbox>
                                </v-flex>
                                <v-flex>
                                    <v-checkbox v-model="d.pue_cortina" label="Cortina" hide-details></v-checkbox>
                                </v-flex>
                                <v-flex>
                                    <v-checkbox v-model="d.pue_mirilla" label="Mirilla" hide-details></v-checkbox>
                                </v-flex>
                                <v-flex>
                                    <v-checkbox v-model="d.pue_antipanico" label="Antipánico" hide-details></v-checkbox>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-text-field
                                            v-model="pu"
                                            readonly
                                            label="Precio Unitario"
                                            :prefix="moneda.signo"
                                            :error-messages="errores.collect('pu')"
                                            data-vv-name="pu"
                                            type="text"
                                            v-validate="'required'"
                                            required></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-text-field
                                            label="Descuento comercial"
                                            v-model="d.descuento_com"
                                            prefix="%"
                                            :error-messages="errores.collect('descuento_com')"
                                            v-validate="{descuento_com:[d.item_id,id]}"
                                            data-vv-name="descuento_com"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-text-field label="Descuento estratégico"
                                                  v-model="d.descuento_est"
                                                  prefix="%"
                                                  :error-messages="errores.collect('descuento_est')"
                                                  v-validate="{descuento_est:[d.item_id,id]}"
                                                  data-vv-name="descuento_est"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-text-field
                                            v-model="subtotal"
                                            readonly
                                            label="Subtotal"
                                            :prefix="moneda.signo"
                                            :error-messages="errores.collect('subtotal')"
                                            v-validate="'required'"
                                            data-vv-name="subtotal"
                                            required></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm3 md3>
                                    <v-text-field
                                            :value="d.pu_orig"
                                            readonly
                                            label="Precio unit orig"
                                            :prefix="moneda.signo"
                                            type="text"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-textarea label="Observaciones"
                                                v-model="d.obs"
                                                multi-line
                                                counter="100"
                                                :error-messages="errores.collect('obs')"
                                                v-validate="'max:100'"
                                                data-vv-name="obs"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" dark :to="'/presupuesto/' + presup">CANCELAR</v-btn>
                            <v-btn color="green" dark @click.native="guardar" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </form>
            </v-flex>
        </v-layout>
        <tabla-items tipo="pue" :presup="presup" :moneda="moneda.id" ref="tabla"></tabla-items>
    </v-container>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import empresaSelect from '../../../components/EmpresaSelect';
    import ubicacionSelect from '../../../components/UbicacionSelect';
    import revisiones from '../../../components/Revisiones';
    import itemSelect from '../../../components/ItemSelect';
    import mixinPresupItem from '../../../mixins/presupuestoItems';
    import mixinItems from '../../../mixins/items';
    import mixinPresupuesto from '../../../mixins/presupuesto';
    import mixinPrecio from '../../../mixins/precios';
    import tablaItems from '../../../components/TablaItems';
    import moneda from '../../../filters/moneda';

    function getInitialData() {
        return {
            item_id: '',
            item_tipo_id: '6',
            cant: 0,
            pu: 0,
            pu_orig: 0,
            subtotal: 0,
            obs: '',
            presupuesto_id: '',
            pue_capilla_alto: '',
            pue_capilla_ancho: '',
            pue_esp_panel: '',
            pue_apertura: '',
            pue_temp: '',
            pue_defensa: false,
            pue_cortina: false,
            pue_mirilla: false,
            pue_antipanico: false,
            pue_proteccion: '',
            pue_esp_piso: '',
            empresa_id: '',
            ubicacion: '',
            stock: false,
            descuento_com: '',
            descuento_est: '',
            ancho: '',
            alto: '',
            fecha_entrega: '',
            plazo_entrega: ''
        }
    }

    export default {
        name: "add",
        $_veeValidate: {
            validator: 'new'
        },
        components: {tablaItems, itemSelect, empresaSelect, ubicacionSelect, revisiones},
        mixins: [mixinPresupItem, mixinItems, mixinPresupuesto, mixinPrecio],
        filters: {moneda},
        data() {
            return {
                menuFechaEntrega: false,
                revision: '',
                revisiones: [],
                item: {id: '', desig: '', codigo: ''},
                moneda: {signo: '', id: ''},
                loading: false,
                loadingPrecio: false,
                descuento_est_monto: 0,
                descuento_com_monto: 0,
                d: getInitialData(),
                editando: false,
                aperturas: [
                    {value: 'd', text: 'Derecha'},
                    {value: 'i', text: 'Izquierda'},
                ],
                protecciones: [
                    {value: 'b', text: 'Bumper'},
                    {value: 'p', text: 'Parachoque'},
                ]
            }
        },
        computed: {
            ...mapState({
                presup: state => state.route.params.presup,
                oper: state => state.route.params.oper,
                id: state => state.route.params.id,
            }),
            titulo() {
                return (this.oper === 'add') ? 'Agregar' : 'Editar';
            },
            pu() {
                let subtot = this.d.pu_orig;
                if (this.d.descuento_com) {
                    this.descuento_com_monto = (subtot / 100) * this.d.descuento_com;
                    subtot = subtot - this.descuento_com_monto;
                }

                if (this.d.descuento_est) {
                    this.descuento_est_monto = (subtot / 100) * this.d.descuento_est;
                    subtot = subtot - this.descuento_est_monto;
                }

                this.d.pu = subtot;
                return new Intl.NumberFormat('es-AR').format(this.d.pu);
            },
            subtotal() {
                this.d.subtotal = this.d.pu * this.d.cant;
                return new Intl.NumberFormat('es-AR').format(this.d.subtotal);
            },
            total() {
                if (!this.items) {
                    return 0
                }
                return this.items.reduce((a, b) => {
                    return a + b.subtotal
                }, 0)
            }
        },
        mounted() {
            this.traeMoneda();
            this.traeDatos();
            this.d.presupuesto_id = this.$store.state.route.params.presup;
        },
        watch: {
            '$route': 'traeDatos',
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            limpiar() {
                this.d = getInitialData();
                this.d.presupuesto_id = this.$store.state.route.params.presup;
                this.item = {};
                this.$validator.reset();
            },
            traePlazo() {
                this.presupuestoPlazo({presupuesto_id: this.d.presupuesto_id}, r => {
                    this.d.plazo_entrega = r;
                }, err => {
                    this.msjShow({txt: 'Error al obtener plazo', tipo: 'error'});
                })
            },
            traeDatos() {
                if (this.oper !== 'edit') {
                    this.traePlazo();
                    return false;
                }
                this.loading = true;
                this.presupuestoItemShow(this.id, r => {
                    this.d = r;
                    this.item = r.item;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            traeMoneda() {
                this.presupuestoMoneda({presupuesto_id: this.presup}, r => {
                    this.moneda = r;
                }, err => {
                    console.log(err)
                })
            },
            guardar() {
                if (!this.d.presupuesto_id) {
                    this.msjShow({txt: 'Falta numero de presupuesto', tipo: 'error'});
                    return false;
                }
                this.$validator.validateAll()
                    .then(r => {
                        console.log(r);
                        if (r) {
                            this.loading = true;
                            if (this.oper === 'edit') {
                                this.presupuestoItemUpdate(this.d, r => {
                                    this.limpiar();
                                    this.loading = false;
                                    this.$refs.tabla.getItems();
                                    this.msjShow(r);
                                    this.$router.push('/presupuesto/' + this.presup);
                                }, e => {
                                    this.msjShow({txt: 'Error de validación', tipo: 'error', errores: (e.errors) ? e.errors : ''});
                                    this.loading = false;
                                })
                            } else {
                                this.presupuestoItemStore(this.d, r => {
                                    this.limpiar();
                                    this.loading = false;
                                    this.$refs.tabla.getItems();
                                    this.msjShow(r);
                                }, e => {
                                    this.msjShow({txt: 'Error de validación', tipo: 'error', errores: (e.response.data.errors) ? e.response.data.errors : ''});
                                    this.loading = false;
                                })
                            }

                        }
                    })
            },
            revisionMostrar() {
                if (this.d.id) {
                    this.loading = true;
                    this.presupuestoItemRevisionShow({id: this.d.id, revision: this.revision}, r => {
                        this.d = r;
                        this.item = r.item;
                        this.loading = false;
                    })
                }
            },
            traePrecio() {
                if (!this.item) {
                    return false;
                }
                this.loadingPrecio = true;
                this.precioBusqueda({
                    producto: this.item.id,
                    empresa: this.d.empresa_id,
                    item_tipo_id: this.d.item_tipo_id
                }, r => {
                    this.d.pu = (r) ? r : 0;
                    this.d.pu_orig = (r) ? r : 0;
                    this.loadingPrecio = false;
                }, err => {
                    console.log(err);
                    this.loadingPrecio = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/item/pue.vue